import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultSelectAllComponent = ({
  selectEverything,
  totalRowCount
}) => {
  return /*#__PURE__*/_jsx(Button, {
    "data-test-id": "select-query-button",
    use: "link",
    onClick: selectEverything,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "datatable.bulkActions.selectQuery",
      options: {
        count: totalRowCount
      }
    })
  });
};
export default DefaultSelectAllComponent;